import type { FC } from 'react';
import React from 'react';
import { SlideOut } from '@interstate/components/SlideOut';
import DealHistoryActivityInterstate from './DealHistoryActivity.interstate';

interface DealHistoryDrawerProps {
    isOpen: boolean;
    onClose: () => void;
}

export const DealHistoryDrawer: FC<DealHistoryDrawerProps> = ({ isOpen, onClose }) => {
    return (
        <SlideOut
            data-testid="deal-history-drawer"
            show={isOpen}
            position="right"
            panelWidth="95vw"
            onHide={onClose}
            header="View and Compare Offer History"
        >
            <DealHistoryActivityInterstate onClose={onClose} isInDrawer />
        </SlideOut>
    );
};
